import { useEffect, useState } from 'react'
import { Detalle, Detalles } from '../api/get-detalles'
import { QueryStatus } from 'src/types'
import { HttpWRC } from '../api'
import {deleteOperationDetail} from "../api/delete-detail";

export const useDetalles = (idOperacion: number) => {
    const [detalles, setDetalles] = useState<Detalle[]>()
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)

    const fetch = () => {
        setStatus(QueryStatus.Loading)

        HttpWRC.getDetalles(idOperacion)
            .then(value => {
                setDetalles(value)
                setStatus(QueryStatus.Success)
            })
            .catch(e => {
                setStatus(QueryStatus.Error)
                console.log(e)
            })
    }

    const refetch = () => fetch();
    
    const deleteOperationDetail = (idOperationDetail: number) => {
        HttpWRC.deleteOperationDetail(idOperacion, idOperationDetail)
            .then(() => {
                fetch();
            })
    }

    useEffect(() => {
        fetch()
    }, [idOperacion])

    return { detalles, refetch, status, deleteOperationDetail }
}
